import { combineReducers } from 'redux';
import userPostCarousel from './userPostCarousel';
import conversation from './conversation';
import currentCampaign from './currentCampaign';
import campaignList from './campaignList';
import tableOnSteroids from './tableOnSteroids';
import featureFlags from './featureFlags';

const rootReducer = combineReducers({
  userPostCarousel,
  conversation,
  currentCampaign,
  campaignList,
  tableOnSteroids,
  featureFlags,
});

export default rootReducer;
